/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-unused-modules */
import locales from './locales'
import { createNavigation } from 'next-intl/navigation'
// The `pathnames` object holds pairs of internal
// and external paths, separated by locale.

export const { Link, redirect, usePathname, useRouter } = createNavigation({
  locales,
})
